const PIXEL_ID = '2089993468600036'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base code, initializes the pixel and fires the
 * initial PageView. Safe to call multiple times — it only runs once.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(
        b.head ||
        b.getElementsByTagName('head')[0] ||
        b.documentElement
      ).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/**
 * Fires the AddToCart standard event. Call when a user clicks a CTA that
 * sends them to the Hotmart checkout.
 */
export function trackAddToCart(params?: {
  value?: number
  currency?: string
  contentName?: string
  contentIds?: string[]
  contentType?: string
}): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'AddToCart', {
    content_name: params?.contentName ?? 'Male Insomnia Protocol',
    content_ids: params?.contentIds ?? ['producto-1'],
    content_type: params?.contentType ?? 'product',
    value: params?.value ?? 6.36,
    currency: params?.currency ?? 'USD',
  })
}
